module.exports = __webpack_public_path__ + "static/img/dynamicImg.46ef3aeb.gif";